export default __webpack_public_path__ + "static/media/bosch-logo.050a5a2f.png";